import React, { useState, useEffect } from "react";
import { EditTwoTone } from "@ant-design/icons";
import { Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../../redux/User/actions";
import UserForm from "./UserForm";
import { fetchCountries } from "../../../redux/Country/actions";
import ErrorBoundary from "./ErrorBoundary"; // Adjust path as needed

export const EditUser = ({ item }) => {
  const dispatch = useDispatch();
  const [Model_visible, setModel_visible] = useState(false);
  const [form] = Form.useForm();
  const countries = useSelector((state) => state.countries?.countries || []);

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const showModal = () => {
    onFill();
    setModel_visible(true);
  };

  const onFill = () => {
    form.setFieldsValue(item);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const form_onfinish = (values) => {
    dispatch(updateUser(item._id, values));
    form.resetFields();
    setModel_visible(false);
  };

  const hideModal_Cancel = () => {
    setModel_visible(false);
    form.resetFields();
  };

  return (
    <>
      <EditTwoTone twoToneColor="blue" key="edit" onClick={showModal} />
      <Modal
        title="Modifier utilisateur"
        visible={Model_visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
      >
        <ErrorBoundary>
          
          <UserForm
            form={form}
            initialValues={item}
            showPassword={false}
            onFinish={form_onfinish}
            countries={countries}
          />
        </ErrorBoundary>
      </Modal>
    </>
  );
};

export default EditUser;
